import { render, staticRenderFns } from "./decline.vue?vue&type=template&id=33678fa0&scoped=true&"
import script from "./decline.vue?vue&type=script&lang=js&"
export * from "./decline.vue?vue&type=script&lang=js&"
import style0 from "./decline.vue?vue&type=style&index=0&id=33678fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33678fa0",
  null
  
)

export default component.exports